export default __webpack_public_path__ + "static/media/915.9580beaf.png";